<template>
    <auto-height :margin="margin" class="send-list-conversation-container">
        <div class="row h-100">
            <div class="col d-flex flex-column h-100">
                <div class="pt-2 pb-2 mt-2 pl-1 pr-1 mb-2 bg-gray-300 font-weight-bold flex-shrink-0 flex-grow-0">
                  <note-viewer :note="note" :store-note-url="storeNoteUrl" :read-only-notes="readOnlyNotes" :send-list-id="sendListId" :can-set-read-only-note="canSetReadOnlyNote"></note-viewer>
                </div>
                <div class="d-flex">
                    <el-input
                        @input="onSearchChanged"
                        v-model="pendingSearch"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar mb-2 mt-2"
                    ></el-input>
                </div>
                <list
                    ref="list"
                    :url="url"
                    @select="onSelect"
                    @edit="onEdit"
                    @delete="onDelete"
                    @open-chat="onOpenChat"
                    @restore="onRestore"
                    @move="onMove"
                    @refresh-start="onListRefreshStarted"
                    @refresh-finish="onListRefreshFinished"
                    class="list"
                    :is-edit="isEdit"
                ></list>
            </div>
        </div>
    </auto-height>
</template>

<script>
  import List from './list';
  import AutoHeight from '../../auto-height';
  import {addQueryParams} from "../../../libs/url";
  import NoteViewer from '../../../components/send-list/note-viewer';

  export default {
    props: {
      debounceDelay: {
        type: Number,
        default: 700,
      },
      margin: {
        type: Number,
        default: 0,
      },
      indexUrl: String,
      note: Object,
      readOnlyNotes: Array,
      storeNoteUrl: String,
      sendListId: Number,
      canSetReadOnlyNote: Boolean,
      isEdit: Boolean,
    },

    data() {
      return {
        filters: {},
        url: null,
        current: null,
        debouncedSearchApply: _.debounce(function (value) {
          const searchFilter = value ? {search: value} : {};
          this.filters = _.assign({}, _.omit(this.filters, 'search'), searchFilter);
          this.applyFilters();
        }, this.debounceDelay),
        pendingSearch: '',
        isListRefreshingActive: false,
      };
    },

    computed: {
      /**
       * @return {String|null}
       */
      search() {
        return this.filters.search || null;
      },
    },

    methods: {
      /**
       * @param {String} value
       */
      onSearchChanged(value) {
        this.debouncedSearchApply(value);
        if (_.size(value) === 0) {
          this.debouncedSearchApply.flush();
        }
      },

      /**
       * @return {undefined}
       */
      applyFilters() {
        this.generateUrl();
      },

      /**
       * @return {undefined}
       */
      generateUrl() {
        this.url = addQueryParams(this.indexUrl, this.filters);
      },

      /**
       * @param {Object} conversation
       */
      onSelect(conversation) {
        this.current = conversation;
        this.$emit('change', conversation);
      },

      /**
       * @param {Object} conversation
       */
      onEdit(conversation) {
        this.current = conversation;
        this.$emit('edit', conversation);
      },

      /**
       * @param {Object} item
       */
      onDelete(item) {
        this.$emit('delete', item);
      },

      /**
       * @param {object} payload
       */
      onOpenChat(payload) {
        this.$emit('open-chat', payload);
      },

      /**
       * @param {object} item
       * @emits restore
       */
      onRestore(item) {
        this.$emit('restore', item);
      },

      /**
       * @param {String} url
       * @emits move
       */
      onMove(url) {
        this.$emit('move', url);
      },

      /**
       * @return {undefined}
       */
      refreshList() {
        this.$refs.list.refresh();
      },

      /**
       * @return {undefined}
       */
      onListRefreshStarted() {
        this.isListRefreshingActive = true;
      },

      /**
       * @return {undefined}
       */
      onListRefreshFinished() {
        this.isListRefreshingActive = false;
      },

      /**
       * @param {Number} id
       */
      removeItemById(id) {
        this.$refs.list.removeItemById(id);
      },

      /**
       * @param {Object} item
       */
      editItem(item) {
        this.$refs.list.editItem(item);
      },
    },

    created() {
      this.generateUrl();
    },

    components: {
      List,
      AutoHeight,
      NoteViewer,
    }
  }
</script>
